import axios from "axios";
import { keyClockUrl } from "./constant";

export const loginFromKeyClock = (obj) => {
  return axios.post(`${keyClockUrl}/iam/v2.0/login`, obj, {
    withCredentials: true,
  });
};

export const getUserContactInfo = () => {
  return axios.get(`${keyClockUrl}/iam/v1.0/employee/info`, {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });
};

export const checkMfaStatus = (userName) => {
  return axios.get(`${keyClockUrl}/iam/v1.0/login/mfa-status`, {
    params: {
      userName: userName,
    },
    withCredentials: true,
  });
};

